import { Link, useState, React, PageStyle, useEffect} from '@/imports-files/components/third-party-logo';
import { CommonAction } from "@/actions/common/common";
import Logo  from "/public/images/logo/logo.svg"

export function ThirdPartyLogo(props)
{
  const commonAction                                =   new CommonAction();
  const [imageClass, setImageClass]                 =   useState(`${PageStyle.ThirdPartyLogo__RectangularLogo}`)

  useEffect(async() => {
    setTimeout(() => {
      const image = document.getElementById("third-party-header-logo"); // Replace 'yourImageId' with the actual ID of your image
      if(image){
        // Get the width and height of the image
        const width = image.width;
        const height = image.height;

        // Calculate the aspect ratio
        const aspectRatio = width / height;
        console.log(width)
        console.log(height)
        console.log(aspectRatio)
        // debugger;
        // Check if it's a square or a rectangle
        if (aspectRatio === 1) {
          setImageClass(`${PageStyle.ThirdPartyLogo__SquareLogo}`)
          // console.log('The image is a square.');
        } else {
          setImageClass(`${PageStyle.ThirdPartyLogo__RectangularLogo}`)
          // console.log('The image is a rectangle.');
        }
      }
    }, 100)
  }, [])
  return(
    commonAction.headerLogoUrl() ? <div className={`${PageStyle.ThirdPartyLogo} ${imageClass}`}>
      <img src={commonAction.headerLogoUrl()}  alt="Third Party Logo" id="third-party-header-logo" onClick={() => console.log('clicked')}
        />
       <span className={`${PageStyle.ThirdPartyLogo__PoweredByCandidly}`}>
          powered by <Logo/>
       </span>
    </div>
    : ''

    );
}

export default ThirdPartyLogo;
